/**
 * The dancing tortoise. `logo.webp` is a smoothed, seamless rebuild of
 * `logo.gif`, which snagged at its loop point in three separate ways: its last
 * two frames were identical (a held frame), its first step was the largest in
 * the animation, and its first ~22 frames carry a warm colour ramp - frame 1 is
 * +0.07 blue against the tone the rest settles on - so the loop both lurched
 * and changed colour.
 *
 * Built from the GIF's own frames by `rebuild-logo.sh` (kept with the project
 * notes, not in this repo):
 *   1. keep source frames 23-71 - past the colour ramp, short of the held pair
 *      at the end. Those two are the hinge points whose neighbouring step is
 *      smallest, 0.015 and 0.024 RMSE;
 *   2. interpolate to 22 fps, which halves the motion per frame;
 *   3. play forward then back, repeating neither endpoint;
 *   4. resize to 80px - what a 40px logo needs on a 2x screen, not the 144px it
 *      used to carry - and encode as animated WebP.
 *
 * The loop now wraps at 0.0097 RMSE and holds its colour to within 0.004 across
 * the cycle. 372 KB against the GIF's 640.
 *
 * The GIF stays as the fallback, so a browser without animated WebP is exactly
 * as well off as it was before.
 */
export function BrandLogo({ className, alt = "" }: { className?: string; alt?: string }) {
  return (
    <picture>
      <source srcSet="/logo.webp" type="image/webp" />
      <img src="/logo.gif" alt={alt} aria-hidden={alt ? undefined : true} className={className} />
    </picture>
  );
}
